import { httpClient } from '@/services/httpClient';
import Bugsnag from '@bugsnag/js';

const getReports = async () => {
    try {
        const response = await httpClient.get('/api/v1/reports')

        return response.data
    } catch (error) {
        // Handle error
        Bugsnag.notify(error)
    }
}

const storeReport = async (payload) => {
    try {
        const response = await httpClient.post('/api/v1/reports', payload)

        return response.data
    } catch (error) {
        // Handle error
        Bugsnag.notify(error)
    }
}

const updateReport = async (id, payload) => {
    try {
        const response = await httpClient.put('/api/v1/reports/' + id, payload)

        return response.data
    } catch (error) {
        // Handle error
        Bugsnag.notify(error)
    }
}

const archiveReport = async (id) => {
    try {
        const response = await httpClient.delete('/api/v1/reports/' + id, null)

        return response.data
    } catch (error) {
        // Handle error
        Bugsnag.notify(error)
    }
}

const copyReport = async (id) => {
    try {
        const response = await httpClient.post('/api/v1/reports/'+ id +'/copy', null)

        return response.data
    } catch (error) {
        // Handle error
        Bugsnag.notify(error)
    }
}


export { getReports, storeReport, updateReport, archiveReport, copyReport }
